module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "app"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "particles-js"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('h1', [_vm._v("Hugo's blog")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "//github.com/Hugo-seth",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//www.zhihu.com/people/shenqihui1992/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "zhihu",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('p', [_vm._v("Copyright © Hugo's Blog 2017")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59c95520!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 99
// module chunks = 3